'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiBrush = function TiBrush(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.6 6.4c-0.6-0.7-1.5-1-2.3-1-0.4 0-0.9 0.1-1.3 0.2-7.4 3-13 8-17.5 15.6-0.2 0.3-0.3 0.6-0.3 0.9-2.3 0.4-4.4 1.5-5.8 3.4-1.5 1.9-2.1 4.4-1.8 7l0.4 2.5 2.5 0.4c0.4 0 0.9 0.1 1.4 0.1 4.6 0 8.3-3.2 9-7.6 0.3-0.1 0.6-0.2 0.9-0.4 7.6-4.5 12.6-10.1 15.6-17.5 0.5-1.3 0.2-2.7-0.8-3.6z m-24.7 25.7c-0.3 0-0.6 0-1 0-0.5-3.5 1.8-6.4 5-6.7l1.7 1.7c-0.3 2.9-2.6 5-5.7 5z m8.2-7.5l-1.7-1.7c0.6-1 1.3-2 1.9-3 0.1 0.1 2.8 2.8 2.8 2.8-1 0.6-2 1.3-3 1.9z m4.3-2.9s-3-3-3.1-3.1c3.6-4.6 7.7-7.8 13-9.9-2.1 5.2-5.3 9.4-9.9 13z' })
        )
    );
};

exports.default = TiBrush;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/brush.js
// module id = 1822
// module chunks = 0